import { warnAboutMissingStyles } from '@entur/utils';
import React from 'react';

var SkipToContent = function SkipToContent(_ref) {
  var children = _ref.children,
    _ref$mainId = _ref.mainId,
    mainId = _ref$mainId === void 0 ? 'main-content' : _ref$mainId;
  return React.createElement("a", {
    className: "eds-skip-to-content",
    href: "#" + mainId
  }, children);
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var _excluded = ["as", "children"];
var VisuallyHidden = function VisuallyHidden(_ref) {
  var _ref$as = _ref.as,
    Element = _ref$as === void 0 ? 'span' : _ref$as,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement(Element, _extends({
    className: "eds-visually-hidden"
  }, rest), children);
};

warnAboutMissingStyles('a11y');

export { SkipToContent, VisuallyHidden };
//# sourceMappingURL=a11y.esm.js.map
